import { useFormik } from "formik";
import React, { useState, useEffect } from "react";
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import CustomInput from "../../Common/CustomInput/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import {
  getTermsandconditionById,
  updateTermsandcondition,
} from "../../../redux/termsandcondition/action";
import Spinner from "../../Layouts/Spinner";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import AddUpdateHeader from "../../Common/CardHeader/AddUpdateHeader";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const formData = [
  { title: "Type", name: "type" },
  { title: "Description", name: "description" },
  { title: "Arabic Description", name: "ar_description" },
  // { title: "Status", name: "status" },
];

const UpdateOffer = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const dispatch = useDispatch();
  const selectedOffer = useSelector(
    ({ termsandcondition: { termsandconditionbyid } }) => termsandconditionbyid,
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      dispatch(getTermsandconditionById(id));
      setUpdate(true);
    }
  }, [dispatch, id]);

  const typeOptions = {
    1: "User T/C",
    2: "Business T/C",
    3: "Driver T/C",
    4: "Cancellation T/C",
    5: "Rescheduling T/C",
  };

  const initialValues = formData.reduce((acc, field) => {
    acc[field.name] = selectedOffer?.[field.name] || "";
    return acc;
  }, {});

  const stripTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || ""; 
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values) => handleSubmit(values),
    enableReinitialize: true,
  });

  const handleSubmit = (values) => {
    setLoading(true);
    const cleanedDescription = stripTags(values.description);
    const cleanedar_Description = stripTags(values.ar_description);

    const data = {
      ...values,
      description: cleanedDescription,
      ar_description: cleanedar_Description,
      id: id,
    };
    dispatch(updateTermsandcondition(data, setLoading,navigate));
    setUpdate(false);
    setLoading(false);
  };

  return (
    <Card className="pt-4 pl-4">
      <AddUpdateHeader
        modal={"Update Terms & Conditions"}
        list={"Terms & Condition List"}
      />
      <CardBody className="">
        <form onSubmit={formik.handleSubmit}>
          <Row className="mx-2">
            {formData.map((prop, key) => {
              if (prop.name === "type") {
                return (
                  <Col className=" " xs={3} key={key}>
                    <label>{t(prop.title)}</label>
                    <div>
                      <ReactSelect
                        value={{
                          label: typeOptions[selectedOffer?.type],
                          value: selectedOffer?.type,
                        }}
                        placeholder={t(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        isDisabled={true}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched[prop.name] &&
                        formik.errors[prop.name] && (
                          <div className="error">
                            {t(formik.errors[prop.name])}
                          </div>
                        )}
                    </div>
                  </Col>
                );
              }

              if (prop.name === "description") {
                return (
                  <Col className=" " xs={12} key={key}>
                    <label>{t(prop.title)}</label>
                    <div
                      style={{
                        height: "120px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        overflowY: "auto",
                      }}
                    >
                      <ReactQuill
                        theme="snow"
                        value={formik.values.description}
                        onChange={(content) =>
                          formik.setFieldValue("description", content)
                        }
                        style={{ height: "100%" }}
                      />
                    </div>
                    {formik.touched[prop.name] && formik.errors[prop.name] && (
                      <div className="error">{t(formik.errors[prop.name])}</div>
                    )}
                  </Col>
                );
              }

              if (prop.name === "ar_description") {
                return (
                  <Col className=" " xs={12} key={key}>
                    <label>{t(prop.title)}</label>
                    <div
                      style={{
                        height: "120px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        overflowY: "auto",
                      }}
                    >
                      <ReactQuill
                        theme="snow"
                        value={formik.values.ar_description}
                        onChange={(content) =>
                          formik.setFieldValue("ar_description", content)
                        }
                         className="rtl-editor"
                        style={{direction:prop.name == "ar_description"? "rtl":"ltr"}}

                        
                      />
                    </div>
                    {formik.touched[prop.name] && formik.errors[prop.name] && (
                      <div className="error">{t(formik.errors[prop.name])}</div>
                    )}
                  </Col>
                );
              }

        
              return (
                <Col className=" " key={key} xs={3}>
                  <div>
                    <label>{t(prop.title)}</label>
                    <CustomInput
                      type={prop.name === "type" ? "text" : "text"}
                      value={formik.values?.[prop.name]}
                      placeholder={prop.title}
                      id={prop.name}
                      name={prop.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      touched={formik.touched}
                      errors={formik.errors}
                    />
                  </div>
                  {formik.touched[prop.name] && formik.errors[prop.name] && (
                    <div className="error">{t(formik.errors[prop.name])}</div>
                  )}
                </Col>
              );
            })}
            <Col xs={12} className="text-center my-3 d-flex align-items-center justify-content-between">
              <Button
                disabled={loading}
                onClick={() => navigate(-1)}
                type="button"
                className="back-btn"
              >
                Back
              </Button>
              <Button
                disabled={loading}
                type="submit"
                className="submit-btn"
              >
                {!loading ? (
                  selectedOffer?.id ? (
                    "Update"
                  ) : (
                    "Submit"
                  )
                ) : (
                  <Spinner />
                )}
              </Button>
            </Col>
          </Row>
        </form>
      </CardBody>
    </Card>
  );
};

export default UpdateOffer;
